import {get, httpDelete, patch, post} from '@/services/infrastructure/api.service'
import {ref} from 'vue'
import {notifyError} from '@/services/infrastructure/notification.service'
import {Left} from '@/types/either/Either'

const DRAFTS_PATH = '/drafts'
export type Draft = {
    uuid?: string,
    editTransactionUuid?: string,
    name: string,
    type: string,
    content: any
}

export enum DRAFT_TYPE {
    TRANSACTION = 'transaction',
    INVOICE = 'invoice'
}

export const useDrafts = () => {

    const loading = ref(true)

    const saveDraft = async (draft: Draft) => {
        loading.value = true

        try {
            return await post(DRAFTS_PATH, draft)
        } catch (e: any) {
            notifyError({ title: 'Feilet', description: { descriptionMessage: `Kunne ikke lagre kladd med type: ${e.type}`, error: e }})
            return []
        } finally {
            loading.value = false
        }
    }

    const deleteDraft = async (uuid: string) => {
        loading.value = true

        try {
            return await httpDelete(DRAFTS_PATH + '/' + uuid)
        } catch (e: any) {
            notifyError({ title: 'Feilet', description: { descriptionMessage: `Kunne ikke slette kladd med type: ${e.type}`, error: e }})
            return []
        } finally {
            loading.value = false
        }
    }

    const updateDraft = async (draft: Draft) => {
        loading.value = true

        try {
            return await patch(DRAFTS_PATH, draft)
        } catch (e: any) {
            notifyError({ title: 'Feilet', description: { descriptionMessage: `Kunne ikke oppdatere kladd med type: ${e.type}`, error: e }})
            return Left.create(e)
        } finally {
            loading.value = false
        }
    }

    const fetchDrafts = async (type: string): Promise<Draft[]> => {
        loading.value = true

        try {
            return await get<Draft[]>(DRAFTS_PATH, {
                type: type
            }) ?? []
        } catch (e: any) {
            notifyError({ title: 'Feilet', description: { descriptionMessage: `Kunne ikke hente kladder med type: ${e.type}`, error: e }})
            return []
        } finally {
            loading.value = false
        }
    }


    return {
        loading,
        saveDraft,
        updateDraft,
        deleteDraft,
        fetchDrafts,
    }
}